import { render, staticRenderFns } from "./ControlAudioSync.vue?vue&type=template&id=1d85c138&scoped=true&"
import script from "./ControlAudioSync.vue?vue&type=script&lang=js&"
export * from "./ControlAudioSync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d85c138",
  null
  
)

export default component.exports